import React, {createContext, useContext, useEffect, useMemo, useReducer, useState} from "react";
import apiFactory from "../api";
import {CODE_TYPE} from "../config/Constant";

const WorkManagementContext = createContext(null);

export const useWorkManagementContext = () => {
  return useContext(WorkManagementContext);
};

export const WorkManagementProvider = ({children}) => {
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [progressStepOptions, setProgressStepOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [authorityOptions, setAuthorityOptions] = useState([]);
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [stageWorkFlowOption, setStageWorkFlowOption] = useState([]);
  const [workActivity, setWorkActivity] = useState([]);
  const [attributeTemplate, setAttributeTemplate] = useState([]);
  const initialState = {};

  const formDataReducer = (state, action) => {
    switch (action.type) {
      case "UPDATE_FIELD":
        return {
          ...state,
          [action.taskCode]: {
            ...state[action.taskCode],
            [action.field]: action.value
          }
        };
      case "SET_FORM_DATA":
        return {
          ...state,
          [action.taskCode]: action.data
        };
      case "RESET_FORM":
        return {
          ...state,
          [action.taskCode]: initialState[action.taskCode] || {
            content: "",
            isRegisterNotice: true,
            selectedWorkActivity: workActivity?.[0]?.code,
            mentionInput: "",
            mentionCodes: []
          }
        };
      default:
        return state;
    }
  };

  const [taskFormData, setTaskFormData] = useReducer(formDataReducer, initialState);

  const getProjectTypeOptions = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.PROJECT_TYPE
    });
    if (response?.status !== 200) return;
    setProjectTypeOptions(response?.data);
  }

  const getProgressStepOption = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.PROGRESS_STEP
    });
    if (response?.status !== 200) return;    
    setProgressStepOptions(response?.data);
  }

  const getRoleOption = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.ROLE
    });
    if (response?.status !== 200) return;
    setRoleOptions(response?.data);
  }

  const getAuthorityOption = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.AUTHORITY
    });
    if (response?.status !== 200) return;
    setAuthorityOptions(response?.data);
  }

  const getStageWorkFLowOption = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.STAGE_WORKFLOW
    });
    if (response?.status !== 200) return;
    setStageWorkFlowOption(response?.data);
  }

  const getPropertyOption = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.PROPERTY
    });
    if (response?.status !== 200) return;
    setPropertyOptions(response?.data);
  }

  const getWorkActivity = async () => {
    const response = await apiFactory.codeApi.getListByCodeTypeNumber({
      codeType: CODE_TYPE.WORK_ACTIVITY
    });
    if (response?.status !== 200) return;
    setWorkActivity(response?.data);
  }

  const getTemplateAttribute = async () => {
    const request = {
      limit: 15,
      page: 1,
      search: null
    }
    const response = await apiFactory.attributeTemplateApi.getList(request);
    if (response?.status !== 200) return;
    setAttributeTemplate(response?.data?.items);
  }

  useEffect(() => {
    getProjectTypeOptions();
    getProgressStepOption();
    getRoleOption();
    getAuthorityOption();
    getStageWorkFLowOption();
    getPropertyOption();
    getWorkActivity();
    getTemplateAttribute();
  }, []);


  const values = useMemo(
    () => ({
      projectTypeOptions,
      progressStepOptions,
      roleOptions,
      authorityOptions,
      propertyOptions,
      stageWorkFlowOption,
      attributeTemplate,
      workActivity,
      taskFormData,
      setTaskFormData
    }),
    [
      projectTypeOptions,
      progressStepOptions,
      roleOptions,
      authorityOptions,
      propertyOptions,
      stageWorkFlowOption,
      attributeTemplate,
      workActivity,
      taskFormData,
      setTaskFormData
    ]
  );
  return (
    <WorkManagementContext.Provider value={values}>
      {children}
    </WorkManagementContext.Provider>
  );
}